import { Vector3D, getDefault } from "@wufe/particles";
import { QuadTree, Box } from "./quad-tree";
export class QuadTreeProximityDetectionSystemBuilder {
}
QuadTreeProximityDetectionSystemBuilder.build = (partialParams) => ({
    build: manager => new QuadTreeProximityDetectionSystem(manager, getDefault(partialParams, {
        radius: 300
    }))
});
export class QuadTreeProximityDetectionSystem {
    constructor(_manager, _params) {
        this._manager = _manager;
        this._params = _params;
        this.quadTree = null;
    }
    init() {
    }
    update(objects) {
        const { width, height, depth } = this._manager.configuration;
        const position = new Vector3D({ x: width / 2, y: height / 2, z: depth / 2 });
        const dimensions = position.clone();
        const boundary = new Box(position, dimensions);
        const quadTree = new QuadTree(boundary);
        objects.forEach(o => quadTree.insert(o));
        this.quadTree = quadTree;
    }
    getNeighbours(object, radius = this._params.radius) {
        const position = object.coords.clone();
        const dimensions = new Vector3D({ x: radius, y: radius, z: radius });
        const possibleNeighbours = this.quadTree.query(new Box(position, dimensions));
        const neighbours = possibleNeighbours
            .filter(n => this._getDistance(object, n) < radius);
        return neighbours;
    }
    _getDistance(obj1, obj2) {
        return Math.hypot(obj2.coords.x - obj1.coords.x, obj2.coords.y - obj1.coords.y, obj2.coords.z - obj1.coords.z);
    }
}
